import React from "react";
import { CaretRight } from "@/components/shared/icons";
import { Badge, View } from "@/components/ui";
import { cn } from "@/lib/utils";

export interface NavbarListItemProps {
  icon?: React.ReactNode;
  title: string;
  isActive?: boolean;
  showTrailingIcon?: boolean;
  badge?: string;
  size?: "large" | "small";
  onClick?: () => void;
}

export function NavbarListItem({
  icon,
  title,
  isActive,
  showTrailingIcon = true,
  badge,
  size = "large",
  onClick,
}: NavbarListItemProps) {
  return (
    <View
      onClick={onClick}
      className={cn(
        "ease color-white flex cursor-pointer flex-row items-center justify-between rounded-xl border border-transparent transition hover:opacity-80",
        isActive && "bg-brand-static-hover",
        {
          "px-4 py-5": size === "large",
          "p-3": size === "small",
        },
      )}
    >
      <View className="flex flex-row items-center">
        {icon && <View className="mr-2.5">{icon}</View>}
        <View>{title}</View>
      </View>
      <View className="flex flex-row items-center">
        {badge && (
          <Badge variant="danger-fill" outline={false} className="py-0">
            {badge}
          </Badge>
        )}
        {showTrailingIcon && <CaretRight />}
      </View>
    </View>
  );
}
